import { useState } from "react";
import {
    TextField,
    Select,
    MenuItem,
    Grid,
} from "@mui/material";

export default function DownlinkForm({ command, onValue }) {
    if (!command) return null;

    const vars = command.input_variables || {};
    const [values, setValues] = useState({});

    const handleChange = (name, value) => {
        setValues((prev) => ({ ...prev, [name]: value }));
        onValue((prev) => ({ ...prev, [name]: value }));
    };


    return (
        <Grid container spacing={2}>
            {Object.entries(vars).map(([name, cfg]) => (
                <Grid item xs={12} md={6} key={name}>
                    {cfg.type === "number" && (
                        <TextField
                            fullWidth
                            type="number"
                            label={cfg.label}
                            defaultValue={cfg.default}
                            inputProps={{
                                min: cfg.min,
                                max: cfg.max
                            }}
                            onChange={(e) => handleChange(name, e.target.value)}
                        />
                    )}

                    {cfg.type === "text" && (
                        <TextField
                            fullWidth
                            label={cfg.label}
                            defaultValue={cfg.default}
                            inputProps={{ maxLength: cfg.maxLength }}
                            onChange={(e) => handleChange(name, e.target.value)}
                        />
                    )}

                    {cfg.type === "select" && (
                        <Select
                            fullWidth
                            defaultValue={cfg.default}
                            onChange={(e) => handleChange(name, e.target.value)}
                        >
                            {cfg.options.map((o) => (
                                <MenuItem key={o.value} value={o.value}>
                                    {o.label}
                                </MenuItem>
                            ))}
                        </Select>
                    )}

                    {cfg.type === "ip" && (
                        <TextField
                            fullWidth
                            label={cfg.label}
                            placeholder="192.168.1.10"
                            onChange={(e) => handleChange(name, e.target.value)}
                        />
                    )}
                </Grid>
            ))}
        </Grid>
    );
}
